import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HiMiniHome, HiOutlineLockClosed } from "react-icons/hi2";
import { HiOutlineMail} from "react-icons/hi";

import { IoIosKey } from "react-icons/io";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { MdSolarPower } from "react-icons/md";
import ButtonLoader from "../../components/common/ButtonLoader";
import logo from "../../Assets/Logos/FooterLogo.svg";
import axios from "axios";
import { toast, Toaster } from "react-hot-toast";
import { useEffect } from "react";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);


  const validateForm = () => {
    let valid = true;
    const newErrors = { email: "", password: "" };

    // Email validation
    if (!email) {
      newErrors.email = "Email is required.";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Please enter a valid email address.";
      valid = false;
    }

    // Password validation
    if (!password) {
      newErrors.password = "Password is required.";
      valid = false;
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };


const handleLogin = async () => {
  if (!validateForm()) return;

  setIsLoading(true);

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/login`,
      { email, password }
    );

    if (!data?.token)
      throw new Error("Token not received");

    // store auth data
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user || {}));
    localStorage.setItem("permissions", JSON.stringify(data.permissions || []));
    localStorage.setItem("sidebar", JSON.stringify(data.sidebar || []));

    if (rememberMe)
      localStorage.setItem("rememberMe", "true");

    toast.success("Login successful!");
    // navigate("/dashboard");

    // safer role detection
    const role =
    (data.user?.role?.name ||
    data.user?.role ||
    "staff").toLowerCase();
    
    console.log("role", role);
    const redirectMap = {
        admin: "/dashboard",
        manager: "/dashboard",
        staff: "/dashboard"
      };
      console.log("first", redirectMap[role]);
      navigate(redirectMap[role] || "/dashboard");
      console.log("navigate to dashboard");
      
  } catch (error) {
    const msg =
      error.response?.data?.message ||
      error.message ||
      "Login failed";

    toast.error(msg);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const base64payload = token.split(".")[1];
    const payload = JSON.parse(atob(base64payload));

    if (!payload.exp) return;

    const exp =
      payload.exp < 9999999999
        ? payload.exp * 1000
        : payload.exp;

    const delay = exp - Date.now();

    if (delay <= 0) {
      localStorage.clear();
      navigate("/login");
      return;
    }

    const timer = setTimeout(() => {
      localStorage.clear();
      navigate("/login");
    }, delay);

    return () => clearTimeout(timer);

  } catch (err) {
    console.error("Invalid token", err);
    localStorage.clear();
    navigate("/login");
  }
}, [navigate]);

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <>
      <Toaster />
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center px-4 relative overflow-hidden">
        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-yellow-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>
        </div>

        {/* Solar panel pattern overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="grid grid-cols-6 gap-4 transform rotate-45 scale-150">
            {[...Array(24)].map((_, i) => (
              <MdSolarPower key={i} className="w-8 h-8 text-white" />
            ))}
          </div>
        </div>

        <div className="w-full max-w-md relative z-10">
          {/* Logo and Brand */}
          <div className="text-center mb-8 animate-fadeInDown">
            <div className="flex justify-center mb-4">
              <div className="relative">
                {/* <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full blur-xl opacity-70 animate-pulse"></div> */}
                <div className="">
                <img src={logo} alt="Logo" className="w-full h-auto object-cover" />
                </div>
              </div>
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">Welcome Back! 👋</h1>
            <p className="text-gray-300">Sign in to continue your solar journey</p>
          </div>

          {/* Login Card */}
          <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl p-8 border border-white/20 animate-fadeInUp">
            <div className="space-y-6">
              {/* Email Input */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-200">
                  Email Address
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <HiOutlineMail className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={handleKeyPress}
                    className={`block w-full pl-10 pr-3 py-3 border ${
                      errors.email ? "border-red-500" : "border-gray-600"
                    } rounded-lg bg-white/5 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all duration-300`}
                    placeholder="Enter your email"
                  />
                </div>
                {errors.email && (
                  <p className="text-xs text-red-400 mt-1 animate-shake">
                    {errors.email}
                  </p>
                )}
              </div>

              {/* Password Input */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-200">
                  Password
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <HiOutlineLockClosed className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={handleKeyPress}
                    className={`block w-full pl-10 pr-10 py-3 border ${
                      errors.password ? "border-red-500" : "border-gray-600"
                    } rounded-lg bg-white/5 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all duration-300`}
                    placeholder="Enter your password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-white transition-colors duration-300"
                  >
                    {showPassword ? <FiEyeOff className="h-5 w-5" /> : <FiEye className="h-5 w-5" />}
                  </button>
                </div>
                {errors.password && (
                  <p className="text-xs text-red-400 mt-1 animate-shake">
                    {errors.password}
                  </p>
                )}
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="remember-me"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="h-4 w-4 rounded border-gray-600 bg-white/5 text-yellow-500 focus:ring-yellow-500 focus:ring-offset-0"
                  />
                  <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-300">
                    Remember me
                  </label>
                </div>
                <button
                  onClick={() => navigate("/forgot-password")}
                  className="text-sm text-yellow-400 hover:text-yellow-300 transition-colors duration-300 flex items-center gap-1"
                >
                  <IoIosKey className="h-4 w-4" />
                  Forgot Password?
                </button>
              </div>

              {/* Login Button */}
              <button
                onClick={handleLogin}
                disabled={isLoading}
                className="relative w-full py-3 px-4 bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-semibold rounded-lg overflow-hidden group disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <div className="absolute inset-0 bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                <span className="relative flex items-center justify-center gap-2">
                  {isLoading ? (
                    <ButtonLoader />
                  ) : (
                    <>
                      <MdSolarPower className="h-5 w-5" />
                      Sign In
                    </>
                  )}
                </span>
              </button>

              {/* Home Link */}
              <div className="text-center">
                <button
                  onClick={() => navigate("/")}
                  className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors duration-300 group"
                >
                  <HiMiniHome className="h-4 w-4 group-hover:scale-110 transition-transform duration-300" />
                  Return to Home
                </button>
              </div>
            </div>
          </div>

          {/* Footer */}
          <p className="text-center mt-6 text-xs text-gray-500">
            © 2024 PM Surya Ghar. All rights reserved.
          </p>
        </div>
      </div>

      {/* Custom Animations */}
      <style jsx>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeInDown {
          animation: fadeInDown 0.6s ease-out;
        }
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.6s ease-out;
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }
          20%, 40%, 60%, 80% { transform: translateX(2px); }
        }
        .animate-shake {
          animation: shake 0.5s ease-in-out;
        }
      `}</style>
    </>
  );
};

export default Login;